import { integer, maxLength, minValue, required, url } from 'vuelidate/lib/validators'

import { date, vattenfallUrl } from '@/validators/customValidators'

export const liquidatedDamageModel = {
  form: {
    name: {
      required,
      maxLength: maxLength(64)
    },
    milestoneName: {
      required,
      maxLength: maxLength(16)
    },
    status: {
    },
    description: {
      maxLength: maxLength(128)
    },
    originalDate: {
      required,
      date
    },
    amendedCompletionDate: {
      date
    },
    actualCompletionDate: {
      date
    },
    eot: {
      integer
    },
    delay: {
      integer
    },
    totalValueCents: {
      integer
    },
    capValueCents: {
      integer
    },
    documentUrl: {
      url,
      vattenfallUrl
    }
  }
}

export const liquidatedDamageCapModel = {
  form: {
    valueCents: {
      integer,
      minValue: minValue(1)
    }
  }
}

export const liquidatedDamageDateModel = {
  form: {
    name: {
      required,
      maxLength: maxLength(64)
    },
    description: {
      maxLength: maxLength(128)
    },
    date: {
      required,
      date
    }
  }
}
